import { InjectionToken } from '@angular/core';

export const TOOLTIP_DEFAULTS = {
  MOBILE_WIDTH: 260,
  DESKTOP_WIDTH: 250,
  ARROW_MARGIN: 25,
  VIEWPORT_MARGIN: 10,
  MOBILE_BREAKPOINT: 770,
  HIDE_DELAY: 8000,
  TOOLTIP_HEIGHT_ESTIMATE: 200,
  DEBOUNCE_TIME: 100, // ✅ OPTIMIZACIÓN: Menos aggressive debouncing para mejor rendimiento
  THROTTLE_TIME: 100, // ✅ OPTIMIZACIÓN: Throttle más conservador para evitar lag (10fps en lugar de 60fps)
  Z_INDEX: 9999,
  CACHE_DURATION: 250 // ✅ OPTIMIZACIÓN: Cache más duradero para reducir getBoundingClientRect calls
} as const;

// ✅ Types exportados
export type TooltipPlacement = 'top' | 'bottom' | 'left' | 'right';
export type TooltipEvent = 'show' | 'hide' | 'toggle';

// ✅ Configuración tipada para el tooltip
export interface TooltipConfig {
  hideDelay: number;
  mobileWidth: number;
  desktopWidth: number;
  viewportMargin: number;
  arrowMargin: number;
  enableA11y: boolean;
}

// ✅ Configuración por defecto
export const DEFAULT_TOOLTIP_CONFIG: TooltipConfig = {
  hideDelay: TOOLTIP_DEFAULTS.HIDE_DELAY,
  mobileWidth: TOOLTIP_DEFAULTS.MOBILE_WIDTH,
  desktopWidth: TOOLTIP_DEFAULTS.DESKTOP_WIDTH,
  viewportMargin: TOOLTIP_DEFAULTS.VIEWPORT_MARGIN,
  arrowMargin: TOOLTIP_DEFAULTS.ARROW_MARGIN,
  enableA11y: true
};

// ✅ Token de inyección
export const TOOLTIP_CONFIG = new InjectionToken<Partial<TooltipConfig>>('tooltip.config');

// ✅ Provider factory para configuración personalizada
export function provideTooltipConfig(config: Partial<TooltipConfig> = {}) {
  return {
    provide: TOOLTIP_CONFIG,
    useValue: { ...DEFAULT_TOOLTIP_CONFIG, ...config }
  };
}

// ✅ Configuración para diferentes casos de uso
export const TOOLTIP_MOBILE_CONFIG: Partial<TooltipConfig> = {
  hideDelay: 6000,
  mobileWidth: 280,
  viewportMargin: 15
};

export const TOOLTIP_DESKTOP_CONFIG: Partial<TooltipConfig> = {
  hideDelay: 10000,
  desktopWidth: 300,
  enableA11y: true
};

export const TOOLTIP_COMPACT_CONFIG: Partial<TooltipConfig> = {
  hideDelay: 4000,
  mobileWidth: 200,
  desktopWidth: 180,
  viewportMargin: 5,
  arrowMargin: 15
};
